module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-warning w-100-if-mobile mb-4-if-mobile",
    attrs: {
      "type": "button",
      "name": "import video"
    },
    on: {
      "click": function($event) {
        _vm.driveIconClicked()
      }
    }
  }, [_vm._v("\n  + Import from Google Drive\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-05ce7505"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoogleFilePicker.vue
// module id = 972
// module chunks = 0